import { useGlobalAlert } from "hooks/useAlert";
import { ActionFunctionArgs, redirect } from "react-router-dom";
import { api } from "services/api.service";

export async function action({ request, params }: ActionFunctionArgs) {
  const formData = await request.formData();
  const entries = Array.from(formData.entries());
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const data = Object.fromEntries(entries.filter(([_, value]) => value !== "" && value != null));
  try {
    const response = await api.request({
      method: "PATCH",
      url: `/inventories/${params.inventoryId}`,
      data,
    });
    if (response.status === 200) {
      useGlobalAlert.alertSuccess("Inventory updated successfully");
      return redirect("../../scan");
    }
  } catch (error) {
    useGlobalAlert.alertError(`Failed to update inventory: ${error}`);
    throw error;
  }
  return null;
}
